import { render, staticRenderFns } from "./ProfileNav.vue?vue&type=template&id=27efd5b0&"
import script from "./ProfileNav.vue?vue&type=script&lang=js&"
export * from "./ProfileNav.vue?vue&type=script&lang=js&"
import style0 from "./ProfileNav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports